import React from 'react'

const WarningIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
      fill="currentColor"
    />
    <path
      d="M7.35318 8.87852C7.35963 9.24718 7.66033 9.54266 8.02904 9.54266C8.39776 9.54266 8.69845 9.24718 8.7049 8.87852L8.77694 4.7611C8.78426 4.34293 8.44728 4 8.02904 4C7.61081 4 7.27383 4.34293 7.28115 4.7611L7.35318 8.87852ZM7.9951 12C8.47025 12 8.79995 11.642 8.79995 11.1273C8.79995 10.6238 8.45086 10.2657 7.9951 10.2657C7.54904 10.2657 7.19995 10.6238 7.19995 11.1273C7.19995 11.642 7.54904 12 7.9951 12Z"
      fill="white"
    />
  </svg>
)

export default WarningIcon
